export { DireccionComponent } from "./direccion/direccion";
export { ColoniaComponent } from "./direccion/colonia";


// WEBPACK FOOTER //
// ./app/features/componentes/index.tsx